const VisionAndMission = () => (
  <div className="site-main-inner-wrapper dark">
    <section>
      <h2>Our vision and mission</h2>
      <p>Mental wellbeing is for all of us.</p>
      <p>
        Our mission is to utilize technology to improve mental health and
        wellbeing for everyone. We empower mental health professionals with
        innovative tools and resources, while making self-help accessible to all
        through our free and open source digital products.
      </p>
    </section>
  </div>
);

export default VisionAndMission;
